<template>
  <main class="rf-impresion">
    <div class="rf-impresion-controles d-print-none">
      <p>Vista de impresión · Carta vertical</p>
      <acciones-reporte
        v-if="sesionLista && reporteValido && contrato && !errorCarga && !$apollo.loading"
        ref="acciones"
        :documento="documento" :reporte="contratoReporteFisico" :contrato="contrato"
        vista-impresion />
      <skeleton-reporte v-else-if="!sesionLista || $apollo.loading" tipo="acciones"
        mensaje="Cargando acciones del reporte…" />
    </div>
    <skeleton-reporte v-if="!sesionLista || $apollo.loading"
      mensaje="Cargando reporte para imprimir…" />
    <div v-else-if="errorCarga" class="rf-impresion-estado" role="alert">
      <h1>No se pudo cargar el reporte</h1>
      <p>Verifica tu conexión y vuelve a intentarlo.</p>
      <v-btn outlined color="primary" @click="reintentar">Reintentar</v-btn>
    </div>
    <div v-else-if="!reporteValido || !contrato" class="rf-impresion-estado" role="alert">
      <h1>Reporte no disponible</h1>
      <p>El reporte no existe o no pertenece al contrato solicitado.</p>
    </div>
    <ver-reporte v-else :reporte-fisico="contratoReporteFisico" :contrato-reporte="contrato"
      :catalogo-conceptos="contratoCatalogoConceptosArbol || []"
      @documento="documento = $event" />
  </main>
</template>

<script>
import SkeletonReporte from '@/components/administracion/ejecucion/reportes/documento/SkeletonReporte.vue';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_CATALOGO_ARBOL from '@/graphql/querys/administracion/contratos/catalogoConceptos/contratoCatalogoConceptosArbol.gql';
import REPORTE from '@/graphql/querys/administracion/ejecucion/reportesFisicos/contratoReporteFisico.gql';
import VerReporte from './reporte/Main.vue';
import AccionesReporte from '@/components/administracion/ejecucion/reportes/documento/AccionesReporte.vue';

export default {
  name: 'ImprimirReporteFisico',
  components: { VerReporte, AccionesReporte, SkeletonReporte },
  data: () => ({
    contrato: null, contratoReporteFisico: null, documento: '', errorCarga: false, impresionIniciada: false,
  }),
  computed: {
    sesionLista() {
      return !this.$auth.isLoading && this.$auth.isAuthenticated
        && (this.$auth.user.scopes || []).includes('Supervisión:ver');
    },
    reporteValido() {
      return !!this.contratoReporteFisico
        && String(this.contratoReporteFisico.idContrato) === String(this.$route.params.idContrato);
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() { return { id: this.$route.params.idContrato }; },
      skip() { return !this.sesionLista; },
      error() { this.errorCarga = true; },
    },
    contratoCatalogoConceptosArbol: {
      query: CONTRATO_CATALOGO_ARBOL,
      variables() { return { idContrato: this.$route.params.idContrato }; },
      skip() { return !this.sesionLista; },
      error() { this.errorCarga = true; },
    },
    contratoReporteFisico: {
      query: REPORTE,
      variables() { return { id: this.$route.params.idReporte }; },
      skip() { return !this.sesionLista; },
      error() { this.errorCarga = true; },
    },
  },
  watch: {
    documento(valor) {
      if (!valor || this.impresionIniciada || this.$route.query.imprimir !== '1') return;
      this.impresionIniciada = true;
      this.$nextTick(() => { if (this.$refs.acciones) this.$refs.acciones.imprimir(); });
    },
  },
  methods: {
    async reintentar() {
      this.errorCarga = false;
      try {
        await Promise.all([
          this.$apollo.queries.contrato.refetch(),
          this.$apollo.queries.contratoCatalogoConceptosArbol.refetch(),
          this.$apollo.queries.contratoReporteFisico.refetch(),
        ]);
      } catch (error) { this.errorCarga = true; }
    },
  },
};
</script>

<style lang="scss">
.rf-impresion { min-height: 100vh; padding: 24px; background: var(--v-bkground-base); }
.rf-impresion-controles {
  max-width: 1100px; margin: 0 auto 20px; display: flex; align-items: flex-start;
  justify-content: space-between; gap: 16px;
}
.rf-impresion-controles > p { margin: 10px 0; font-size: 14px; color: var(--v-primary-base); }
.rf-impresion-estado { text-align: center; padding: 60px 24px; }
.rf-impresion-estado h1 { font-size: 24px; }
.rf-impresion-estado p { margin-top: 16px; }
@media screen and (max-width: 600px) {
  .rf-impresion { padding: 12px; }
  .rf-impresion-controles { flex-direction: column; }
}
@media print {
  .rf-impresion { padding: 0 !important; background: white; min-height: 0; }
  #app > .v-application > .v-application--wrap > .v-footer,
  #contenedor-global-snack-bar, .v-snack, .v-overlay { display: none !important; }
}
</style>
